import { ListItem, ListItemText, ListItemIcon, makeStyles} from "@material-ui/core";

interface Props {
  primaryText?: string;
  secondaryText?: string;
  icon?: JSX.Element;
}

export const AppListItem = ({ primaryText, secondaryText, icon }: Props) => {
  const classes = useStyles();
  return (
  <ListItem>
    {icon && <ListItemIcon>{icon}</ListItemIcon>}
    <ListItemText className={classes.listItem} primary={primaryText} secondary={secondaryText} />
  </ListItem>
)};

const useStyles = makeStyles(() => ({
  "listItem": {
    "&> span":{
      color: "gray",
      fontSize: "0.8rem"
    },
    "&> p":{
      color: "black",
    }
  }
}),
{ index: 1 },
);
